module.exports = __webpack_public_path__ + "media/brands/rover-32307d24.png";